import { Controller } from "@hotwired/stimulus"

// data-clipboard-source に指定した要素の value / textContent をクリップボードにコピーし、
// 押したボタンの文言を一時的に「コピーしました」に変えてフィードバックする。
export default class extends Controller {
  static values = { feedbackDuration: { type: Number, default: 1500 } }

  async copy(event) {
    const button = event.currentTarget
    const source = document.getElementById(button.dataset.clipboardSource)
    if (!source) return

    const isFormField = source instanceof HTMLInputElement || source instanceof HTMLTextAreaElement
    const text = isFormField ? source.value : source.textContent

    try {
      await navigator.clipboard.writeText(text)
      this.showFeedback(button, "コピーしました")
    } catch (error) {
      console.error("クリップボードへのコピーに失敗しました:", error)
      this.showFeedback(button, "コピーできませんでした")
    }
  }

  showFeedback(button, message) {
    if (button.dataset.originalLabel === undefined) {
      button.dataset.originalLabel = button.textContent
    }
    button.textContent = message
    clearTimeout(button._clipboardTimer)
    button._clipboardTimer = setTimeout(() => {
      button.textContent = button.dataset.originalLabel
    }, this.feedbackDurationValue)
  }
}
